function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { UIPlugin } from '@uppy/core';
import StatusBar from '@uppy/status-bar';
import Informer from '@uppy/informer';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import findAllDOMElements from '@uppy/utils/lib/findAllDOMElements';
import toArray from '@uppy/utils/lib/toArray';
import getDroppedFiles from '@uppy/utils/lib/getDroppedFiles';
import { defaultPickerIcon } from '@uppy/provider-views';
import { nanoid } from 'nanoid/non-secure';
import memoizeOne from 'memoize-one';
import * as trapFocus from "./utils/trapFocus.js";
import createSuperFocus from "./utils/createSuperFocus.js";
import DashboardUI from "./components/Dashboard.js";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.9.1"
};
import locale from "./locale.js";
var memoize = memoizeOne.default || memoizeOne;
var TAB_KEY = 9;
var ESC_KEY = 27;
function createPromise() {
  var o = {};
  o.promise = new Promise(function (resolve, reject) {
    o.resolve = resolve;
    o.reject = reject;
  });
  return o;
}
// set default options, must be kept in sync with packages/@uppy/react/src/DashboardModal.js
var defaultOptions = {
  target: 'body',
  metaFields: [],
  inline: false,
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: 'image/jpeg',
  waitForThumbnailsBeforeUpload: false,
  defaultPickerIcon: defaultPickerIcon,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  singleFileFullScreen: true,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: 'files',
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  showNativePhotoCameraButton: false,
  showNativeVideoCameraButton: false,
  theme: 'light',
  autoOpen: null,
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // Dynamic default options, they have to be defined in the constructor (because
  // they require access to the `this` keyword), but we still want them to
  // appear in the default options so TS knows they'll be defined.
  doneButtonHandler: undefined,
  onRequestCloseModal: null
};

/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */
var _disabledNodes = /*#__PURE__*/_classPrivateFieldLooseKey("disabledNodes");
var _generateLargeThumbnailIfSingleFile = /*#__PURE__*/_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var _openFileEditorWhenFilesAdded = /*#__PURE__*/_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var _attachRenderFunctionToTarget = /*#__PURE__*/_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var _isTargetSupported = /*#__PURE__*/_classPrivateFieldLooseKey("isTargetSupported");
var _getAcquirers = /*#__PURE__*/_classPrivateFieldLooseKey("getAcquirers");
var _getProgressIndicators = /*#__PURE__*/_classPrivateFieldLooseKey("getProgressIndicators");
var _getEditors = /*#__PURE__*/_classPrivateFieldLooseKey("getEditors");
var _addSpecifiedPluginsFromOptions = /*#__PURE__*/_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var _autoDiscoverPlugins = /*#__PURE__*/_classPrivateFieldLooseKey("autoDiscoverPlugins");
var _addSupportedPluginIfNoTarget = /*#__PURE__*/_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
var Dashboard = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Dashboard, _UIPlugin);
  // Timeouts

  function Dashboard(uppy, _opts) {
    var _this;
    _classCallCheck(this, Dashboard);
    var _this$opts4, _this$opts4$onRequest;
    // support for the legacy `autoOpenFileEditor` option,
    // TODO: we can remove this code when we update the Uppy major version
    var autoOpen;
    if (!_opts) {
      autoOpen = null;
    } else if (_opts.autoOpen === undefined) {
      autoOpen = _opts.autoOpenFileEditor ? 'imageEditor' : null;
    } else {
      autoOpen = _opts.autoOpen;
    }
    _this = _callSuper(this, Dashboard, [uppy, _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), _opts), {}, {
      autoOpen: autoOpen
    })]);
    Object.defineProperty(_assertThisInitialized(_this), _disabledNodes, {
      writable: true,
      value: void 0
    });
    _this.modalName = "uppy-Dashboard-".concat(nanoid());
    _this.superFocus = createSuperFocus();
    _this.ifFocusedOnUppyRecently = false;
    _this.removeTarget = function (plugin) {
      var pluginState = _this.getPluginState();
      // filter out the one we want to remove
      var newTargets = pluginState.targets.filter(function (target) {
        return target.id !== plugin.id;
      });
      _this.setPluginState({
        targets: newTargets
      });
    };
    _this.addTarget = function (plugin) {
      var callerPluginId = plugin.id || plugin.constructor.name;
      var callerPluginName = plugin.title || callerPluginId;
      var callerPluginType = plugin.type;
      if (callerPluginType !== 'acquirer' && callerPluginType !== 'progressindicator' && callerPluginType !== 'editor') {
        var msg = 'Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor';
        _this.uppy.log(msg, 'error');
        return null;
      }
      var target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      };
      var state = _this.getPluginState();
      var newTargets = state.targets.slice();
      newTargets.push(target);
      _this.setPluginState({
        targets: newTargets
      });
      return _this.el;
    };
    _this.hideAllPanels = function () {
      var _state$activePickerPa;
      var state = _this.getPluginState();
      var update = {
        activePickerPanel: undefined,
        showAddFilesPanel: false,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: false
      };
      if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) {
        // avoid doing a state update if nothing changed
        return;
      }
      _this.setPluginState(update);
      _this.uppy.emit('dashboard:close-panel', (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
    };
    _this.showPanel = function (id) {
      var _this$getPluginState = _this.getPluginState(),
        targets = _this$getPluginState.targets;
      var activePickerPanel = targets.find(function (target) {
        return target.type === 'acquirer' && target.id === id;
      });
      _this.setPluginState({
        activePickerPanel: activePickerPanel,
        activeOverlayType: 'PickerPanel'
      });
      _this.uppy.emit('dashboard:show-panel', id);
    };
    _this.canEditFile = function (file) {
      var _this$getPluginState2 = _this.getPluginState(),
        targets = _this$getPluginState2.targets;
      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getEditors)[_getEditors](targets);
      return editors.some(function (target) {
        return _this.uppy.getPlugin(target.id).canEditFile(file);
      });
    };
    _this.openFileEditor = function (file) {
      var _this$getPluginState3 = _this.getPluginState(),
        targets = _this$getPluginState3.targets;
      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getEditors)[_getEditors](targets);
      _this.setPluginState({
        showFileEditor: true,
        fileCardFor: file.id || null,
        activeOverlayType: 'FileEditor'
      });
      editors.forEach(function (editor) {
        ;
        _this.uppy.getPlugin(editor.id).selectFile(file);
      });
    };
    _this.closeFileEditor = function () {
      var _this$getPluginState4 = _this.getPluginState(),
        metaFields = _this$getPluginState4.metaFields;
      var isMetaEditorEnabled = metaFields && metaFields.length > 0;
      if (isMetaEditorEnabled) {
        _this.setPluginState({
          showFileEditor: false,
          activeOverlayType: 'FileCard'
        });
      } else {
        _this.setPluginState({
          showFileEditor: false,
          fileCardFor: null,
          activeOverlayType: 'AddFiles'
        });
      }
    };
    _this.saveFileEditor = function () {
      var _this$getPluginState5 = _this.getPluginState(),
        targets = _this$getPluginState5.targets;
      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getEditors)[_getEditors](targets);
      editors.forEach(function (editor) {
        ;
        _this.uppy.getPlugin(editor.id).save();
      });
      _this.closeFileEditor();
    };
    _this.openModal = function () {
      var _createPromise = createPromise(),
        promise = _createPromise.promise,
        resolve = _createPromise.resolve;
      // save scroll position
      _this.savedScrollPosition = window.pageYOffset;
      // save active element, so we can restore focus when modal is closed
      _this.savedActiveElement = document.activeElement;
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.add('uppy-Dashboard-isFixed');
      }
      if (_this.opts.animateOpenClose && _this.getPluginState().isClosing) {
        var handler = function handler() {
          _this.setPluginState({
            isHidden: false
          });
          _this.el.removeEventListener('animationend', handler, false);
          resolve();
        };
        _this.el.addEventListener('animationend', handler, false);
      } else {
        _this.setPluginState({
          isHidden: false
        });
        resolve();
      }
      if (_this.opts.browserBackButtonClose) {
        _this.updateBrowserHistory();
      }

      // handle ESC and TAB keys in modal dialog
      document.addEventListener('keydown', _this.handleKeyDownInModal);
      _this.uppy.emit('dashboard:modal-open');
      return promise;
    };
    _this.closeModal = function (opts) {
      var _opts$manualClose;
      // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
      var manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
      var _this$getPluginState6 = _this.getPluginState(),
        isHidden = _this$getPluginState6.isHidden,
        isClosing = _this$getPluginState6.isClosing;
      if (isHidden || isClosing) {
        // short-circuit if animation is ongoing
        return undefined;
      }
      var _createPromise2 = createPromise(),
        promise = _createPromise2.promise,
        resolve = _createPromise2.resolve;
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove('uppy-Dashboard-isFixed');
      }
      if (_this.opts.animateOpenClose) {
        _this.setPluginState({
          isClosing: true
        });
        var handler = function handler() {
          _this.setPluginState({
            isHidden: true,
            isClosing: false
          });
          _this.superFocus.cancel();
          _this.savedActiveElement.focus();
          _this.el.removeEventListener('animationend', handler, false);
          resolve();
        };
        _this.el.addEventListener('animationend', handler, false);
      } else {
        _this.setPluginState({
          isHidden: true
        });
        _this.superFocus.cancel();
        _this.savedActiveElement.focus();
        resolve();
      }

      // handle ESC and TAB keys in modal dialog
      document.removeEventListener('keydown', _this.handleKeyDownInModal);
      if (manualClose) {
        if (_this.opts.browserBackButtonClose) {
          var _history$state;
          // Make sure that the latest entry in the history state is our modal name
          // eslint-disable-next-line no-restricted-globals
          if ((_history$state = history.state) != null && _history$state[_this.modalName]) {
            // Go back in history to clear out the entry we created (ultimately closing the modal)
            // eslint-disable-next-line no-restricted-globals
            history.back();
          }
        }
      }
      _this.uppy.emit('dashboard:modal-closed');
      return promise;
    };
    _this.isModalOpen = function () {
      return !_this.getPluginState().isHidden || false;
    };
    _this.requestCloseModal = function () {
      if (_this.opts.onRequestCloseModal) {
        return _this.opts.onRequestCloseModal();
      }
      return _this.closeModal();
    };
    _this.setDarkModeCapability = function (isDarkModeOn) {
      var _this$uppy$getState = _this.uppy.getState(),
        capabilities = _this$uppy$getState.capabilities;
      _this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          darkMode: isDarkModeOn
        })
      });
    };
    _this.handleSystemDarkModeChange = function (event) {
      var isDarkModeOnNow = event.matches;
      _this.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnNow ? 'on' : 'off'));
      _this.setDarkModeCapability(isDarkModeOnNow);
    };
    _this.toggleFileCard = function (show, fileID) {
      var file = _this.uppy.getFile(fileID);
      if (show) {
        _this.uppy.emit('dashboard:file-edit-start', file);
      } else {
        _this.uppy.emit('dashboard:file-edit-complete', file);
      }
      _this.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? 'FileCard' : null
      });
    };
    _this.toggleAddFilesPanel = function (show) {
      _this.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? 'AddFiles' : null
      });
    };
    _this.addFiles = function (files) {
      var descriptors = files.map(function (file) {
        return {
          source: _this.id,
          name: file.name,
          type: file.type,
          data: file,
          meta: {
            // path of the file relative to the ancestor directory the user selected.
            // e.g. 'docs/Old Prague/airbnb.pdf'
            relativePath: file.relativePath || file.webkitRelativePath || null
          }
        };
      });
      try {
        _this.uppy.addFiles(descriptors);
      } catch (err) {
        _this.uppy.log(err);
      }
    };
    // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
    //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
    //    another (e.g. in Safari)
    // ___Why not apply visibility property to .uppy-Dashboard-inner?
    //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
    //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
    _this.startListeningToResize = function () {
      // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
      // and update containerWidth/containerHeight in plugin state accordingly.
      // Emits first event on initialization.
      _this.resizeObserver = new ResizeObserver(function (entries) {
        var uppyDashboardInnerEl = entries[0];
        var _uppyDashboardInnerEl = uppyDashboardInnerEl.contentRect,
          width = _uppyDashboardInnerEl.width,
          height = _uppyDashboardInnerEl.height;
        _this.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: true
        });
      });
      _this.resizeObserver.observe(_this.el.querySelector('.uppy-Dashboard-inner'));

      // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
      _this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(function () {
        var pluginState = _this.getPluginState();
        var isModalAndClosed = !_this.opts.inline && pluginState.isHidden;
        if (
        // We might want to enable this in the future

        // if ResizeObserver hasn't yet fired,
        !pluginState.areInsidesReadyToBeVisible &&
        // and it's not due to the modal being closed
        !isModalAndClosed) {
          _this.uppy.log('[Dashboard] resize event didn’t fire on time: defaulted to mobile layout', 'warning');
          _this.setPluginState({
            areInsidesReadyToBeVisible: true
          });
        }
      }, 1000);
    };
    _this.stopListeningToResize = function () {
      _this.resizeObserver.disconnect();
      clearTimeout(_this.makeDashboardInsidesVisibleAnywayTimeout);
    };
    // Records whether we have been interacting with uppy right now,
    // which is then used to determine whether state updates should trigger a refocusing.
    _this.recordIfFocusedOnUppyRecently = function (event) {
      if (_this.el.contains(event.target)) {
        _this.ifFocusedOnUppyRecently = true;
      } else {
        _this.ifFocusedOnUppyRecently = false;
        // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
        //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
        //    previously run superFocus sometimes hits and moves focus back to Uppy.
        _this.superFocus.cancel();
      }
    };
    _this.disableInteractiveElements = function (disable) {
      var _classPrivateFieldLoo;
      var NODES_TO_DISABLE = ['a[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[role="button"]:not([disabled])'];
      var nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : toArray(_this.el.querySelectorAll(NODES_TO_DISABLE)).filter(function (node) {
        return !node.classList.contains('uppy-Dashboard-close');
      });
      var _iterator = _createForOfIteratorHelper(nodesToDisable),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          // Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
          if (node.tagName === 'A') {
            node.setAttribute('aria-disabled', disable);
          } else {
            node.disabled = disable;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (disable) {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _disabledNodes)[_disabledNodes] = nodesToDisable;
      } else {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _disabledNodes)[_disabledNodes] = null;
      }
      _this.dashboardIsDisabled = disable;
    };
    _this.updateBrowserHistory = function () {
      var _history$state2;
      // Ensure history state does not already contain our modal name to avoid double-pushing
      // eslint-disable-next-line no-restricted-globals
      if (!((_history$state2 = history.state) != null && _history$state2[_this.modalName])) {
        // Push to history so that the page is not lost on browser back button press
        // eslint-disable-next-line no-restricted-globals
        history.pushState(_objectSpread(_objectSpread({}, history.state), {}, _defineProperty({}, _this.modalName, true)), '');
      }

      // Listen for back button presses
      window.addEventListener('popstate', _this.handlePopState, false);
    };
    _this.handlePopState = function (event) {
      var _event$state;
      // Close the modal if the history state no longer contains our modal name
      if (_this.isModalOpen() && (!event.state || !event.state[_this.modalName])) {
        _this.closeModal({
          manualClose: false
        });
      }

      // When the browser back button is pressed and uppy is now the latest entry
      // in the history but the modal is closed, fix the history by removing the
      // uppy history entry.
      // This occurs when another entry is added into the history state while the
      // modal is open, and then the modal gets manually closed.
      // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
      if (!_this.isModalOpen() && (_event$state = event.state) != null && _event$state[_this.modalName]) {
        // eslint-disable-next-line no-restricted-globals
        history.back();
      }
    };
    _this.handleKeyDownInModal = function (event) {
      // close modal on esc key press
      if (event.keyCode === ESC_KEY) _this.requestCloseModal();
      // trap focus on tab key press
      if (event.keyCode === TAB_KEY) trapFocus.forModal(event, _this.getPluginState().activeOverlayType, _this.el);
    };
    _this.handleClickOutside = function () {
      if (_this.opts.closeModalOnClickOutside) _this.requestCloseModal();
    };
    _this.handlePaste = function (event) {
      // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
      _this.uppy.iteratePlugins(function (plugin) {
        if (plugin.type === 'acquirer') {
          // Every Plugin with .type acquirer can define handleRootPaste(event)
          ;
          plugin.handleRootPaste == null || plugin.handleRootPaste(event);
        }
      });

      // Add all dropped files
      var files = toArray(event.clipboardData.files);
      if (files.length > 0) {
        _this.uppy.log('[Dashboard] Files pasted');
        _this.addFiles(files);
      }
    };
    _this.handleInputChange = function (event) {
      event.preventDefault();
      var files = toArray(event.target.files);
      if (files.length > 0) {
        _this.uppy.log('[Dashboard] Files selected through input');
        _this.addFiles(files);
      }
    };
    _this.handleDragOver = function (event) {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault();
      event.stopPropagation();

      // Check if some plugin can handle the datatransfer without files —
      // for instance, the Url plugin can import a url
      var canSomePluginHandleRootDrop = function canSomePluginHandleRootDrop() {
        var somePluginCanHandleRootDrop = true;
        _this.uppy.iteratePlugins(function (plugin) {
          if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) {
            somePluginCanHandleRootDrop = true;
          }
        });
        return somePluginCanHandleRootDrop;
      };

      // Check if the "type" of the datatransfer object includes files
      var doesEventHaveFiles = function doesEventHaveFiles() {
        var types = event.dataTransfer.types;
        return types.some(function (type) {
          return type === 'Files';
        });
      };

      // Deny drop, if no plugins can handle datatransfer, there are no files,
      // or when opts.disabled is set, or new uploads are not allowed
      var somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
      var hasFiles = doesEventHaveFiles();
      if (!somePluginCanHandleRootDrop && !hasFiles || _this.opts.disabled ||
      // opts.disableLocalFiles should only be taken into account if no plugins
      // can handle the datatransfer
      _this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !_this.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = 'none'; // eslint-disable-line no-param-reassign
        clearTimeout(_this.removeDragOverClassTimeout);
        return;
      }

      // Add a small (+) icon on drop
      // (and prevent browsers from interpreting this as files being _moved_ into the
      // browser, https://github.com/transloadit/uppy/issues/1978).
      event.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign

      clearTimeout(_this.removeDragOverClassTimeout);
      _this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts = _this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    };
    _this.handleDragLeave = function (event) {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(_this.removeDragOverClassTimeout);
      // Timeout against flickering, this solution is taken from drag-drop library.
      // Solution with 'pointer-events: none' didn't work across browsers.
      _this.removeDragOverClassTimeout = setTimeout(function () {
        _this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = _this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    };
    _this.handleDrop = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var _this$opts$onDrop, _this$opts3, executedDropErrorOnce, logDropError, files;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              clearTimeout(_this.removeDragOverClassTimeout);
              _this.setPluginState({
                isDraggingOver: false
              });

              // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
              _this.uppy.iteratePlugins(function (plugin) {
                if (plugin.type === 'acquirer') {
                  // Every Plugin with .type acquirer can define handleRootDrop(event)
                  ;
                  plugin.handleRootDrop == null || plugin.handleRootDrop(event);
                }
              });

              // Add all dropped files
              executedDropErrorOnce = false;
              logDropError = function logDropError(error) {
                _this.uppy.log(error, 'error');

                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                  _this.uppy.info(error.message, 'error');
                  executedDropErrorOnce = true;
                }
              };
              _this.uppy.log('[Dashboard] Processing dropped files');

              // Add all dropped files
              _context.next = 10;
              return getDroppedFiles(event.dataTransfer, {
                logDropError: logDropError
              });
            case 10:
              files = _context.sent;
              if (files.length > 0) {
                _this.uppy.log('[Dashboard] Files dropped');
                _this.addFiles(files);
              }
              (_this$opts$onDrop = (_this$opts3 = _this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.handleRequestThumbnail = function (file) {
      if (!_this.opts.waitForThumbnailsBeforeUpload) {
        _this.uppy.emit('thumbnail:request', file);
      }
    };
    /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */
    _this.handleCancelThumbnail = function (file) {
      if (!_this.opts.waitForThumbnailsBeforeUpload) {
        _this.uppy.emit('thumbnail:cancel', file);
      }
    };
    _this.handleKeyDownInInline = function (event) {
      // Trap focus on tab key press.
      if (event.keyCode === TAB_KEY) trapFocus.forInline(event, _this.getPluginState().activeOverlayType, _this.el);
    };
    // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
    //    or this.el.addEventListener('paste')?
    //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
    //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
    //       particular Uppy instance.
    // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
    //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
    //    standard determination of whether we're pasting into our Uppy instance won't work.
    //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
    _this.handlePasteOnBody = function (event) {
      var isFocusInOverlay = _this.el.contains(document.activeElement);
      if (isFocusInOverlay) {
        _this.handlePaste(event);
      }
    };
    _this.handleComplete = function (_ref) {
      var failed = _ref.failed;
      if (_this.opts.closeAfterFinish && !(failed != null && failed.length)) {
        // All uploads are done
        _this.requestCloseModal();
      }
    };
    _this.handleCancelRestore = function () {
      _this.uppy.emit('restore-canceled');
    };
    Object.defineProperty(_assertThisInitialized(_this), _generateLargeThumbnailIfSingleFile, {
      writable: true,
      value: function value() {
        if (_this.opts.disableThumbnailGenerator) {
          return;
        }
        var LARGE_THUMBNAIL = 600;
        var files = _this.uppy.getFiles();
        if (files.length === 1) {
          var thumbnailGenerator = _this.uppy.getPlugin("".concat(_this.id, ":ThumbnailGenerator"));
          thumbnailGenerator == null || thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });
          var fileForThumbnail = _objectSpread(_objectSpread({}, files[0]), {}, {
            preview: undefined
          });
          thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(function () {
            thumbnailGenerator == null || thumbnailGenerator.setOptions({
              thumbnailWidth: _this.opts.thumbnailWidth
            });
          });
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _openFileEditorWhenFilesAdded, {
      writable: true,
      value: function value(files) {
        var firstFile = files[0];
        var _this$getPluginState7 = _this.getPluginState(),
          metaFields = _this$getPluginState7.metaFields;
        var isMetaEditorEnabled = metaFields && metaFields.length > 0;
        var isImageEditorEnabled = _this.canEditFile(firstFile);
        if (isMetaEditorEnabled && _this.opts.autoOpen === 'metaEditor') {
          _this.toggleFileCard(true, firstFile.id);
        } else if (isImageEditorEnabled && _this.opts.autoOpen === 'imageEditor') {
          _this.openFileEditor(firstFile);
        }
      }
    });
    _this.initEvents = function () {
      // Modal open button
      if (_this.opts.trigger && !_this.opts.inline) {
        var showModalTrigger = findAllDOMElements(_this.opts.trigger);
        if (showModalTrigger) {
          showModalTrigger.forEach(function (trigger) {
            return trigger.addEventListener('click', _this.openModal);
          });
        } else {
          _this.uppy.log('Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself', 'warning');
        }
      }
      _this.startListeningToResize();
      document.addEventListener('paste', _this.handlePasteOnBody);
      _this.uppy.on('plugin-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      _this.uppy.on('plugin-remove', _this.removeTarget);
      _this.uppy.on('file-added', _this.hideAllPanels);
      _this.uppy.on('dashboard:modal-closed', _this.hideAllPanels);
      _this.uppy.on('complete', _this.handleComplete);
      _this.uppy.on('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      _this.uppy.on('file-removed', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);

      // ___Why fire on capture?
      //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
      document.addEventListener('focus', _this.recordIfFocusedOnUppyRecently, true);
      document.addEventListener('click', _this.recordIfFocusedOnUppyRecently, true);
      if (_this.opts.inline) {
        _this.el.addEventListener('keydown', _this.handleKeyDownInInline);
      }
      if (_this.opts.autoOpen) {
        _this.uppy.on('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    _this.removeEvents = function () {
      var showModalTrigger = findAllDOMElements(_this.opts.trigger);
      if (!_this.opts.inline && showModalTrigger) {
        showModalTrigger.forEach(function (trigger) {
          return trigger.removeEventListener('click', _this.openModal);
        });
      }
      _this.stopListeningToResize();
      document.removeEventListener('paste', _this.handlePasteOnBody);
      window.removeEventListener('popstate', _this.handlePopState, false);
      _this.uppy.off('plugin-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      _this.uppy.off('plugin-remove', _this.removeTarget);
      _this.uppy.off('file-added', _this.hideAllPanels);
      _this.uppy.off('dashboard:modal-closed', _this.hideAllPanels);
      _this.uppy.off('complete', _this.handleComplete);
      _this.uppy.off('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      _this.uppy.off('file-removed', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.removeEventListener('focus', _this.recordIfFocusedOnUppyRecently);
      document.removeEventListener('click', _this.recordIfFocusedOnUppyRecently);
      if (_this.opts.inline) {
        _this.el.removeEventListener('keydown', _this.handleKeyDownInInline);
      }
      if (_this.opts.autoOpen) {
        _this.uppy.off('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this), _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    _this.superFocusOnEachUpdate = function () {
      var isFocusInUppy = _this.el.contains(document.activeElement);
      // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
      var isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
      var isInformerHidden = _this.uppy.getState().info.length === 0;
      var isModal = !_this.opts.inline;
      if (
      // If update is connected to showing the Informer - let the screen reader calmly read it.
      isInformerHidden && (
      // If we are in a modal - always superfocus without concern for other elements
      // on the page (user is unlikely to want to interact with the rest of the page)
      isModal ||
      // If we are already inside of Uppy, or
      isFocusInUppy ||
      // If we are not focused on anything BUT we have already, at least once, focused on uppy
      //   1. We focus when isFocusNowhere, because when the element we were focused
      //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
      //      something somewhere else on the page, - focus won't be 'nowhere'.
      //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
      //      to avoid focus jumps if we do something else on the page.
      //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
      //                     when file is uploading, - navigate via tab to the checkbox,
      //                     try to press space multiple times. Focus will jump to Uppy.
      isFocusNowhere && _this.ifFocusedOnUppyRecently)) {
        _this.superFocus(_this.el, _this.getPluginState().activeOverlayType);
      } else {
        _this.superFocus.cancel();
      }
    };
    _this.afterUpdate = function () {
      if (_this.opts.disabled && !_this.dashboardIsDisabled) {
        _this.disableInteractiveElements(true);
        return;
      }
      if (!_this.opts.disabled && _this.dashboardIsDisabled) {
        _this.disableInteractiveElements(false);
      }
      _this.superFocusOnEachUpdate();
    };
    _this.saveFileCard = function (meta, fileID) {
      _this.uppy.setFileMeta(fileID, meta);
      _this.toggleFileCard(false, fileID);
    };
    Object.defineProperty(_assertThisInitialized(_this), _attachRenderFunctionToTarget, {
      writable: true,
      value: function value(target) {
        var plugin = _this.uppy.getPlugin(target.id);
        return _objectSpread(_objectSpread({}, target), {}, {
          icon: plugin.icon || _this.opts.defaultPickerIcon,
          render: plugin.render
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _isTargetSupported, {
      writable: true,
      value: function value(target) {
        var plugin = _this.uppy.getPlugin(target.id);
        // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
        if (typeof plugin.isSupported !== 'function') {
          return true;
        }
        return plugin.isSupported();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _getAcquirers, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'acquirer' && _classPrivateFieldLooseBase(_assertThisInitialized(_this), _isTargetSupported)[_isTargetSupported](target);
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_assertThisInitialized(_this), _getProgressIndicators, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'progressindicator';
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_assertThisInitialized(_this), _getEditors, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'editor';
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    _this.render = function (state) {
      var pluginState = _this.getPluginState();
      var files = state.files,
        capabilities = state.capabilities,
        allowNewUpload = state.allowNewUpload;
      var _this$uppy$getObjectO = _this.uppy.getObjectOfFilesPerState(),
        newFiles = _this$uppy$getObjectO.newFiles,
        uploadStartedFiles = _this$uppy$getObjectO.uploadStartedFiles,
        completeFiles = _this$uppy$getObjectO.completeFiles,
        erroredFiles = _this$uppy$getObjectO.erroredFiles,
        inProgressFiles = _this$uppy$getObjectO.inProgressFiles,
        inProgressNotPausedFiles = _this$uppy$getObjectO.inProgressNotPausedFiles,
        processingFiles = _this$uppy$getObjectO.processingFiles,
        isUploadStarted = _this$uppy$getObjectO.isUploadStarted,
        isAllComplete = _this$uppy$getObjectO.isAllComplete,
        isAllErrored = _this$uppy$getObjectO.isAllErrored,
        isAllPaused = _this$uppy$getObjectO.isAllPaused;
      var acquirers = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getAcquirers)[_getAcquirers](pluginState.targets);
      var progressindicators = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getProgressIndicators)[_getProgressIndicators](pluginState.targets);
      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getEditors)[_getEditors](pluginState.targets);
      var theme;
      if (_this.opts.theme === 'auto') {
        theme = capabilities.darkMode ? 'dark' : 'light';
      } else {
        theme = _this.opts.theme;
      }
      if (['files', 'folders', 'both'].indexOf(_this.opts.fileManagerSelectionType) < 0) {
        _this.opts.fileManagerSelectionType = 'files';
        // eslint-disable-next-line no-console
        console.warn("Unsupported option for \"fileManagerSelectionType\". Using default of \"".concat(_this.opts.fileManagerSelectionType, "\"."));
      }
      return DashboardUI({
        state: state,
        isHidden: pluginState.isHidden,
        files: files,
        newFiles: newFiles,
        uploadStartedFiles: uploadStartedFiles,
        completeFiles: completeFiles,
        erroredFiles: erroredFiles,
        inProgressFiles: inProgressFiles,
        inProgressNotPausedFiles: inProgressNotPausedFiles,
        processingFiles: processingFiles,
        isUploadStarted: isUploadStarted,
        isAllComplete: isAllComplete,
        isAllErrored: isAllErrored,
        isAllPaused: isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload: allowNewUpload,
        acquirers: acquirers,
        theme: theme,
        disabled: _this.opts.disabled,
        disableLocalFiles: _this.opts.disableLocalFiles,
        direction: _this.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: _this.saveFileEditor,
        closeFileEditor: _this.closeFileEditor,
        disableInteractiveElements: _this.disableInteractiveElements,
        animateOpenClose: _this.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators: progressindicators,
        editors: editors,
        autoProceed: _this.uppy.opts.autoProceed,
        id: _this.id,
        closeModal: _this.requestCloseModal,
        handleClickOutside: _this.handleClickOutside,
        handleInputChange: _this.handleInputChange,
        handlePaste: _this.handlePaste,
        inline: _this.opts.inline,
        showPanel: _this.showPanel,
        hideAllPanels: _this.hideAllPanels,
        i18n: _this.i18n,
        i18nArray: _this.i18nArray,
        uppy: _this.uppy,
        note: _this.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || false,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: _this.toggleFileCard,
        toggleAddFilesPanel: _this.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: _this.saveFileCard,
        openFileEditor: _this.openFileEditor,
        canEditFile: _this.canEditFile,
        width: _this.opts.width,
        height: _this.opts.height,
        showLinkToFileUploadResult: _this.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: _this.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: _this.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: _this.opts.hideCancelButton,
        hideRetryButton: _this.opts.hideRetryButton,
        hidePauseResumeButton: _this.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: _this.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: _this.isTargetDOMEl,
        parentElement: _this.el,
        allowedFileTypes: _this.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: _this.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: _this.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: _this.opts.showSelectedFiles,
        showNativePhotoCameraButton: _this.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: _this.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: _this.opts.nativeCameraFacingMode,
        singleFileFullScreen: _this.opts.singleFileFullScreen,
        handleCancelRestore: _this.handleCancelRestore,
        handleRequestThumbnail: _this.handleRequestThumbnail,
        handleCancelThumbnail: _this.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: _this.handleDragOver,
        handleDragLeave: _this.handleDragLeave,
        handleDrop: _this.handleDrop
      });
    };
    Object.defineProperty(_assertThisInitialized(_this), _addSpecifiedPluginsFromOptions, {
      writable: true,
      value: function value() {
        var plugins = _this.opts.plugins || [];
        plugins.forEach(function (pluginID) {
          var plugin = _this.uppy.getPlugin(pluginID);
          if (plugin) {
            ;
            plugin.mount(_assertThisInitialized(_this), plugin);
          } else {
            _this.uppy.log("[Uppy] Dashboard could not find plugin '".concat(pluginID, "', make sure to uppy.use() the plugins you are specifying"), 'warning');
          }
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _autoDiscoverPlugins, {
      writable: true,
      value: function value() {
        _this.uppy.iteratePlugins(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _addSupportedPluginIfNoTarget, {
      writable: true,
      value: function value(plugin) {
        var _plugin$opts;
        // Only these types belong on the Dashboard,
        // we wouldn’t want to try and mount Compressor or Tus, for example.
        var typesAllowed = ['acquirer', 'editor'];
        if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
          var pluginAlreadyAdded = _this.getPluginState().targets.some(function (installedPlugin) {
            return plugin.id === installedPlugin.id;
          });
          if (!pluginAlreadyAdded) {
            ;
            plugin.mount(_assertThisInitialized(_this), plugin);
          }
        }
      }
    });
    _this.install = function () {
      // Set default state for Dashboard
      _this.setPluginState({
        isHidden: true,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: false,
        activePickerPanel: undefined,
        showFileEditor: false,
        metaFields: _this.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: false,
        isDraggingOver: false
      });
      var _this$opts5 = _this.opts,
        inline = _this$opts5.inline,
        closeAfterFinish = _this$opts5.closeAfterFinish;
      if (inline && closeAfterFinish) {
        throw new Error('[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.');
      }
      var _this$uppy$opts = _this.uppy.opts,
        allowMultipleUploads = _this$uppy$opts.allowMultipleUploads,
        allowMultipleUploadBatches = _this$uppy$opts.allowMultipleUploadBatches;
      if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) {
        _this.uppy.log('[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true', 'warning');
      }
      var target = _this.opts.target;
      if (target) {
        _this.mount(target, _assertThisInitialized(_this));
      }
      if (!_this.opts.disableStatusBar) {
        _this.uppy.use(StatusBar, {
          id: "".concat(_this.id, ":StatusBar"),
          target: _assertThisInitialized(_this),
          hideUploadButton: _this.opts.hideUploadButton,
          hideRetryButton: _this.opts.hideRetryButton,
          hidePauseResumeButton: _this.opts.hidePauseResumeButton,
          hideCancelButton: _this.opts.hideCancelButton,
          showProgressDetails: _this.opts.showProgressDetails,
          hideAfterFinish: _this.opts.hideProgressAfterFinish,
          locale: _this.opts.locale,
          doneButtonHandler: _this.opts.doneButtonHandler
        });
      }
      if (!_this.opts.disableInformer) {
        _this.uppy.use(Informer, {
          id: "".concat(_this.id, ":Informer"),
          target: _assertThisInitialized(_this)
        });
      }
      if (!_this.opts.disableThumbnailGenerator) {
        _this.uppy.use(ThumbnailGenerator, {
          id: "".concat(_this.id, ":ThumbnailGenerator"),
          thumbnailWidth: _this.opts.thumbnailWidth,
          thumbnailHeight: _this.opts.thumbnailHeight,
          thumbnailType: _this.opts.thumbnailType,
          waitForThumbnailsBeforeUpload: _this.opts.waitForThumbnailsBeforeUpload,
          // If we don't block on thumbnails, we can lazily generate them
          lazy: !_this.opts.waitForThumbnailsBeforeUpload
        });
      }

      // Dark Mode / theme
      _this.darkModeMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
      var isDarkModeOnFromTheStart = _this.darkModeMediaQuery ? _this.darkModeMediaQuery.matches : false;
      _this.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnFromTheStart ? 'on' : 'off'));
      _this.setDarkModeCapability(isDarkModeOnFromTheStart);
      if (_this.opts.theme === 'auto') {
        var _this$darkModeMediaQu;
        (_this$darkModeMediaQu = _this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(_this.handleSystemDarkModeChange);
      }
      _classPrivateFieldLooseBase(_assertThisInitialized(_this), _addSpecifiedPluginsFromOptions)[_addSpecifiedPluginsFromOptions]();
      _classPrivateFieldLooseBase(_assertThisInitialized(_this), _autoDiscoverPlugins)[_autoDiscoverPlugins]();
      _this.initEvents();
    };
    _this.uninstall = function () {
      if (!_this.opts.disableInformer) {
        var informer = _this.uppy.getPlugin("".concat(_this.id, ":Informer"));
        // Checking if this plugin exists, in case it was removed by uppy-core
        // before the Dashboard was.
        if (informer) _this.uppy.removePlugin(informer);
      }
      if (!_this.opts.disableStatusBar) {
        var statusBar = _this.uppy.getPlugin("".concat(_this.id, ":StatusBar"));
        if (statusBar) _this.uppy.removePlugin(statusBar);
      }
      if (!_this.opts.disableThumbnailGenerator) {
        var thumbnail = _this.uppy.getPlugin("".concat(_this.id, ":ThumbnailGenerator"));
        if (thumbnail) _this.uppy.removePlugin(thumbnail);
      }
      var plugins = _this.opts.plugins || [];
      plugins.forEach(function (pluginID) {
        var plugin = _this.uppy.getPlugin(pluginID);
        if (plugin) plugin.unmount();
      });
      if (_this.opts.theme === 'auto') {
        var _this$darkModeMediaQu2;
        (_this$darkModeMediaQu2 = _this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(_this.handleSystemDarkModeChange);
      }
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove('uppy-Dashboard-isFixed');
      }
      _this.unmount();
      _this.removeEvents();
    };
    _this.id = _this.opts.id || 'Dashboard';
    _this.title = 'Dashboard';
    _this.type = 'orchestrator';
    _this.defaultLocale = locale;

    // Dynamic default options:
    if (_this.opts.doneButtonHandler === undefined) {
      // `null` means "do not display a Done button", while `undefined` means
      // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
      _this.opts.doneButtonHandler = function () {
        _this.uppy.clearUploadedFiles();
        _this.requestCloseModal();
      };
    }
    (_this$opts4$onRequest = (_this$opts4 = _this.opts).onRequestCloseModal) != null ? _this$opts4$onRequest : _this$opts4.onRequestCloseModal = function () {
      return _this.closeModal();
    };
    _this.i18nInit();
    return _this;
  }
  return _createClass(Dashboard);
}(UIPlugin);
export { Dashboard as default };
Dashboard.VERSION = packageJson.version;